import React from "react";

import { useRaffleContext } from "../../../../../../../(custom-header)/spring-daily-raffle/context";
import { EARN_POINTS_COLORS } from "../../../../../../../(custom-header)/spring-daily-raffle/utils";

const PremiiZilnicTab = () => {
  const { activeCompetitions, hasSubscription, onCompetitionClick } = useRaffleContext();

  return (
    <div>
      {/*info*/}
      <div className={""}>
        <div className={"text-center uppercase text-dark-1 font-bold text-lg leading-6 mb-6 lg:text-xl lg:leading-6.5"}>
          JUST ENTER & COLLECT TICKETS
        </div>
        <div
          className={"text-center mb-3 lg:mb-4 text-sm lg:text-base text-gray-1 leading-5 lg:leading-5.5 font-normal"}>
          Simply enter as usual and automatically earn draw tickets.
          <br className="max-lg:hidden" /> The more you play, the more chances you have.
        </div>
        <div className="relative overflow-hidden lg:w-full lg:max-w-[442px] lg:mx-auto bg-[#EFEFEF] rounded-lg">
          {/* <div className="absolute top-0 left-0 px-1.5 lg:px-2 py-0.5 lg:py-[3px] bg-gradient-botb rounded-br-lg">
            <div className="text-[10px] lg:text-xs font-medium leading-[12px] lg:leading-4 text-white whitespace-nowrap">
              SUBSCRIBERS ONLY
            </div>
          </div> */}

          <div className="flex items-center py-2 lg:py-4 pl-4 lg:px-4 pr-3 gap-2 lg:gap-3 min-h-[64px] lg:min-h-[100px]">
            <div className="flex items-center gap-2 lg:gap-3">
              <img
                src="/assets/images/big-7-draws/botb-pass-entries.webp"
                alt="BOTB Pass"
                className="shrink-0 w-[60px] h-6 lg:w-20 lg:h-8 object-contain"
              />
              {/* <img src="/assets/images/leaderboard/2x.webp" alt="2x points" className="shrink-0 w-10 lg:w-[64px]" /> */}
              <div className="min-w-0 text-xs font-medium leading-4 lg:text-base lg:leading-[22px] text-secondary">
                Subscribers earn <span className="font-bold">DOUBLE ENTRIES on all tickets!</span>
              </div>
            </div>

            {!hasSubscription ? (
              <a
                href="/botb-pass?utm_medium=leaderboard-everybody-wins"
                className="flex items-center justify-center shrink-0 ml-auto min-h-8 lg:min-h-10 w-[100px] lg:w-[130px] px-2.5 py-1 text-xs lg:text-base font-medium text-center whitespace-nowrap bg-[#3268E8] text-white rounded-lg cursor-pointer">
                Subscribe now
              </a>
            ) : null}
          </div>
        </div>
      </div>

      {/*rows*/}
      <div className={"pb-6 lg:pb-4"}>
        {activeCompetitions.map(item => {
          return (
            <>
              <div
                className={
                  "flex items-center max-lg:w-full px-2 lg:px-0 py-3 border-b border-black/8 last:border-b-0 lg:last:border-b-0"
                }>
                <div className={"mr-3 rounded"}>
                  <img
                    src={item.CompetitionThumbnailPicture}
                    alt={"Placeholder"}
                    width={48}
                    height={48}
                    className="object-cover size-11 rounded lg:size-14"
                  />
                </div>
                <div>
                  <div
                    className={`text-sm lg:text-base leading-5 lg:leading-5.5 font-medium mb-1 lg:mb-2 ${EARN_POINTS_COLORS[item.NavigationColour as keyof typeof EARN_POINTS_COLORS]?.title}`}>
                    {item.Title} {item.AdditionalCashText ? item.AdditionalCashText : null}
                  </div>
                  <div className={`flex gap-1 ${item.Reference.includes("DC") ? "items-start" : "items-center"}`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="14"
                      viewBox="0 0 18 14"
                      fill="none"
                      className={"size-5"}>
                      <path
                        d="M17.3333 4.78933V1.33333C17.3333 0.596667 16.7367 0 16 0H1.33333C0.596667 0 0 0.596667 0 1.33333V4.78933C0.775333 5.06467 1.33333 5.79733 1.33333 6.66667C1.33333 7.536 0.775333 8.26867 0 8.544V12C0 12.7367 0.596667 13.3333 1.33333 13.3333H16C16.7367 13.3333 17.3333 12.7367 17.3333 12V8.544C16.558 8.26867 16 7.536 16 6.66667C16 5.79733 16.558 5.06467 17.3333 4.78933ZM12.368 5.974L10.4333 7.414L11.152 9.716C11.2487 10.0247 10.898 10.2793 10.634 10.092L8.66667 8.69733L6.69933 10.092C6.43533 10.2793 6.08533 10.0247 6.18133 9.716L6.9 7.414L4.96533 5.974C4.706 5.78133 4.84 5.36933 5.16333 5.36533L7.57467 5.33733L8.34667 3.05267C8.45 2.74667 8.88333 2.74667 8.98667 3.05267L9.75867 5.33733L12.17 5.36533C12.4933 5.36867 12.6273 5.78067 12.368 5.974Z"
                        fill="#898994"
                      />
                    </svg>
                    <div className={"flex flex-col"}>
                      <div className={"text-xs font-medium leading-4 lg:text-sm lg:leading-5"}>
                        <strong className={"text-dark-1"}>{item.Points}</strong> draw tickets
                      </div>
                      {item.Reference.includes("DC") && (
                        <div
                          className={
                            "text-[#898994] font-jost text-[10px] font-medium leading-3 lg:text-xs lg:leading-4"
                          }>
                          + extra draw tickets for add-ons
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  onClick={() => onCompetitionClick(item)}
                  className={
                    "cursor-pointer uppercase bg-[#EEEEEF] ml-auto text-center px-2.5 py-1 rounded-lg text-nav-azure font-jost text-xs font-medium leading-normal min-h-8 lg:min-h-10 lg:min-w-20 flex-center lg:text-sm lg:leading-5"
                  }>
                  Enter
                </div>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default PremiiZilnicTab;
